import {useEffect, useMemo, useRef, useState} from 'react'
import {SidebarClassificationNode} from '../models/SidebarClassificationNode'
import {useTypedDispatch, useTypedSelector} from '../../util/store'
import {Drawer, IconButton, Typography} from '@mui/material'
import './ClassificationTreeDrawer.scss'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import {selectCurrentUser} from '../../user/rtkUserApi'
import {useSelector} from 'react-redux'
import {useGetDatxClassificationTreeQuery} from '../../search/rtkSearchApi'
import {Close} from '@mui/icons-material'
import {setDrawerOpen} from '../headerSlice'
import { RichTreeView } from '@mui/x-tree-view'
import { CustomTreeItem } from './CustomTreeViewComponent'


const DrawerClassificationTree = () => {

    const user = useSelector(selectCurrentUser)
    const {drawerOpen} = useTypedSelector((state) => state.header)
    const dispatch = useTypedDispatch()
    const {data:classificationTree} = useGetDatxClassificationTreeQuery(undefined, {skip : !user})
    const [expanded, setExpanded] = useState<string[]>([])
    const containerRef = useRef<HTMLDivElement>(null)
    const previousScrollTopRef = useRef<number | null>(null)

    const handleToggle = (event: React.SyntheticEvent | null, nodeIds: string[]) => {
        setExpanded((nodeIds))
    }

    useEffect(() => {
        const container = containerRef.current
        if (container && previousScrollTopRef.current !== null) {
            container.scrollTop = previousScrollTopRef.current
            previousScrollTopRef.current = null
        }
    }, [setExpanded])

    const handleScroll = () => {
        const container = containerRef.current
        if (container) {
            previousScrollTopRef.current = container.scrollTop
        }
    }

    const items = useMemo(() => classificationTree && classificationTree.children ? [...classificationTree.children] : [], [classificationTree])

    return (
        <Drawer
            className={'side-menu-drawer ' + (drawerOpen ? 'open' : '')}
            id="side-menu-drawer"
            variant="persistent"
            anchor="left"
            open={drawerOpen}
        >
              <div className="side-menu-container" ref={containerRef} onScroll={handleScroll}>
                <div className="side-menu-header">
                    <span className="side-menu-title">Browse by Item Classifications</span>
                    <IconButton
                        className="drawer-close"
                        size="small"
                        onClick={() => dispatch(setDrawerOpen(!drawerOpen))}
                    >
                        <Close/>
                    </IconButton>
                </div>
                <RichTreeView
                    disableSelection={true}
                    expandedItems={expanded}
                    itemChildrenIndentation="16px"
                    expansionTrigger="iconContainer"
                    onExpandedItemsChange={handleToggle}
                    className="side-menu-tree"
                    aria-label="rich object"
                    slots={{ 
                        collapseIcon: ArrowDropDownIcon,
                        expandIcon: ArrowRightIcon,
                        item: CustomTreeItem
                    }}
                    defaultExpandedItems={['root']}
                    items={items}
                />
            </div>
        </Drawer>

    )
}

export default DrawerClassificationTree